import { ref } from 'vue';

/**
 * Normalize the supported slab API shapes to the field names used by the
 * viewer while preserving every field from the original record.
 */
export function normalizeSlabItem(item) {
    return {
        ...item,
        slabs: item.slabs ?? item.available_slabs,
        lot: item.lot ?? item.lot_number,
    };
}

export function useSlabData(props = {}) {
    const items = ref([]);
    const allItems = ref([]);
    const loading = ref(true);

    // Counts used for availability checks
    const slabCount = ref(1);
    const stockCount = ref(0);
    const availableCount = ref(0);

    const initialProductInfo = props.initialProductInfo || null;

    const getData = async () => {
        const baseUrl = '';
        const slabUrl = ''; // https://materialselect.pentalonline.com/api/blocks/sunvalley
        const useLocalData = true;
        let slabData;

        const metaProductInfo = document.querySelector('meta[name="mm-product-info"]')?.getAttribute('content') || null;
        if (useLocalData && (initialProductInfo || metaProductInfo || window.productInfo)) {
            const info = initialProductInfo || metaProductInfo || window.productInfo;
            slabData = typeof info === 'string' ? JSON.parse(info) : info;
        } else {
            const response = await fetch(slabUrl);
            slabData = await response.json();
        }

        const singleUrl = window.singleUrl || '';

        return slabData
            .map(item => {
                const normalizedItem = normalizeSlabItem(item);

                return {
                    ...normalizedItem,
                    tags: normalizedItem.tags ? normalizedItem.tags : '',
                    thumbnail: normalizedItem.thumbnail || '',
                    type: "Slab",
                    url: normalizedItem.permalink ? normalizedItem.permalink : `${baseUrl}/${singleUrl ? singleUrl + '/' : ''}${normalizedItem.slug}/${normalizedItem.id}`,
                    category: {
                        ...normalizedItem.category,
                        format: [],
                        brand: []
                    }
                };
            })
            .sort((a, b) => a.name.localeCompare(b.name));
    };

    /**
     * Helper to load data into items refs
     */
    const loadData = async () => {
        const data = await getData();
        items.value = data;
        allItems.value = [...data];
        return data;
    };

    return {
        items,
        allItems,
        loading,
        slabCount,
        stockCount,
        availableCount,
        getData,
        loadData
    };
}
